import * as R from 'ramda';

export const cartIncludesGalaTicket = R.pipe(
  R.find(R.propEq('sku', '1234')),
  Boolean
);
